import React from "react";
import PropTypes from "prop-types";
import { FieldText } from "@conserveit/blocks";
import { connect } from "react-redux";
import DynamicFormComponent from "./DynamicFormComponent";

@connect(
  (state) => ({
    userEmail: state.auth.user.email,
    isFormDisabled: state.reportGenerator.isFormDisabled,
  }),
  null,
  null,
  { forwardRef: true }
)
export default class EmailSelect extends DynamicFormComponent {
  static propTypes = {
    userEmail: PropTypes.string.isRequired,
    isFormDisabled: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      emailAddresses: this.props.userEmail,
      isFormValid: true,
    };
  }

  handleEmailAddressChange = (e) => {
    this.setState({ emailAddresses: e.target.value, isFormValid: true });
  };

  validate = () => {
    if (!this.state.emailAddresses) {
      this.setState({ isFormValid: false });
      return false;
    }
    return true;
  };

  getSelectedValues = () => {
    return { emailAddresses: this.state.emailAddresses };
  };

  render() {
    return (
      <FieldText
        label="Email Address"
        type="email"
        name="email"
        help="Split each email address with a comma."
        error={!this.state.isFormValid && "Email is required"}
        value={this.state.emailAddresses}
        onChange={this.handleEmailAddressChange}
        disabled={this.props.isFormDisabled}
      />
    );
  }
}
